<div class="d-flex flex-column min-vh-100 justify-content-center align-items-center">
    <div class="container text-center p-5">
        <h1>Spray and Wait & Density-Aware Spray and Wait Simulator</h1><hr>
        <p><strong>Note: </strong> This simulator works best in FireFox, especially with a large number of nodes.</p><hr><br>

        <div class="form-group row">
            <label for="input-algorithm" class="col-sm-3 col-form-label"><h5>Algorithm:</h5></label>
            <div class="col-sm-9">
                <select class="form-control" id="input-algorithm" (change)="updateAlgorithm($any($event.target))">
                    <option value="{{ MessagingSystem.SprayAndWait }}">Spray and Wait</option>
                    <option value="{{ MessagingSystem.DensityAwareSprayAndWait }}">Density-Aware Spray and Wait</option>
                </select>
            </div>
        </div>

        <div class="form-group row" *ngIf="algorithm == MessagingSystem.SprayAndWait">
            <label for="input-number-of-msg-copies" class="col-sm-3 col-form-label"><h5>Number of Message Copies (n):</h5></label>
            <div class="col-sm-9">
                <input type="number" 
                       min="{{ settings.MIN_MESSAGE_COPIES }}" 
                       max="{{ settings.MAX_MESSAGE_COPIES }}" 
                       class="form-control" 
                       id="input-number-of-copies"
                       placeholder="Enter number of copies" 
                       [value]="numMsgCopies"
                       (input)='updateNumMsgCopies($any($event.target))'
                >
                <small id="emailHelp" class="form-text text-muted text-left">
                    Enter the number of message copies, between {{ settings.MIN_MESSAGE_COPIES }} and {{ settings.MAX_MESSAGE_COPIES }}.
                </small>
            </div>
        </div>

        <div class="form-group row">
            <label for="input-number-of-nodes" class="col-sm-3 col-form-label"><h5>Number of Nodes:</h5></label>
            <div class="col-sm-9">
                <input type="number" 
                       min="{{ settings.MIN_NUMBER_OF_NODES }}" 
                       max="{{ settings.MAX_NUMBER_OF_NODES }}" 
                       class="form-control" 
                       id="input-number-of-nodes"
                       placeholder="Enter number of nodes" 
                       [value]="numNodes"
                       (input)='updateNumNodes($any($event.target))'
                      
                >
                <small id="emailHelp" class="form-text text-muted text-left">
                    Enter the number of nodes, between {{ settings.MIN_NUMBER_OF_NODES }} and {{ settings.MAX_NUMBER_OF_NODES }}.
                </small>
            </div>
        </div>

        <div class="form-group row">
            <label for="input-node-radius" class="col-sm-3 col-form-label">
                <h5>Node Radius:</h5>
            </label>
            <div class="col-sm-9">
                <br>
                <input  type="range" 
                        class="form-control-range" 
                        id="input-number-of-node" 
                        min="{{ settings.MIN_NODE_RADIUS }}" 
                        max="{{ settings.MAX_NODE_RADIUS }}" 
                        step="1"
                        [value]="nodeRadius"
                        (input)='updateNodeRadius($any($event.target))'
                >
            </div>
        </div>

        <div class="form-group row">
            <label for="input-number-of-nodes" class="col-sm-3 col-form-label">
                <h5>Simulation Speed:</h5>
            </label>
            <div class="col-sm-9">
                <br>
                <input  type="range" 
                        class="form-control-range" 
                        id="input-number-of-node" 
                        min="{{ settings.MIN_SIMULATION_SPEED }}" 
                        max="{{ settings.MAX_SIMULATION_SPEED - 0.5 }}" 
                        step="0.1"
                        [value]="simSpeed"
                        (input)='updateSimSpeed($any($event.target))'
                >
            </div>
        </div>

        <div class="form-group row">
            <label for="input-simulation-time" class="col-sm-3 col-form-label"><h5>Duration of Simulation:</h5></label>
            <div class="col-sm-9">
                <input type="number" 
                       min="{{ settings.MIN_SIMULATION_TIME }}" 
                       max="{{ settings.MAX_SIMULATION_TIME }}" 
                       class="form-control" 
                       id="input-simulation-time"
                       placeholder="Enter number of nodes" 
                       [value]="simTime"
                       (input)='updateSimTime($any($event.target))'
                      
                >
                <small id="emailHelp" class="form-text text-muted text-left">
                    Enter the time for the simulation, between {{ settings.MIN_SIMULATION_TIME }} and {{ settings.MAX_SIMULATION_TIME }}.
                </small>
            </div>
        </div>

        <div class="form-group row">
            <label for="input-number-of-nodes" class="col-sm-3 col-form-label">
                <h5>Message Frequency:</h5>
            </label>
            <div class="col-sm-9">
                <br>
                <input  type="range" 
                        class="form-control-range" 
                        id="input-number-of-node" 
                        min="{{ settings.MIN_MESSAGE_FREQUENCY }}" 
                        max="{{ settings.MAX_MESSAGE_FREQUENCY }}" 
                        [value]="msgFreq"
                        (input)='updateMsgFreq($any($event.target))'
                >
            </div>
        </div>

        <button class="btn btn-primary" (click)="startSimulation()">Get Started</button>
    </div>
</div>